import { render } from "./icon-document-import.vue?vue&type=template&id=443f0358"
import script from "./icon-document-import.vue?vue&type=script&lang=js"
export * from "./icon-document-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__